import { BrowserRouter as Router, Route } from "react-router-dom";
import Home from "./components/Home.jsx";

function App() {
  return (
    <Router>
      <Route path="/" exact render={() => <Home />} />
    </Router>
  );
}

export default App;
